import React from "react";
import { VMProvider } from "../../commons/base/providers/provider";
import VendorItemDashboardViewModel from "./view_models/vendor_item_dashboard_view_model";
import Scaffold from "../../commons/scaffold/scaffold";
import VendorItemDashboardTableWidget from "./widgets/vendor_item_dashboard_table_widget";
import VendorItemDashboardSearchWidget from "./widgets/vendor_item_dashboard_filter_widget";
import SizedDiv from "../../commons/ui/sized_div";
import VendorItemDashboardItemsModalWidget from "./widgets/vendor_item_dashboard_items_modal_widget";
import VendorItemDashboardCreateVendorModalWidget from "./widgets/vendor_item_dashboard_create_vendor_modal_widget";

export default class VendorItemdashboardScreen extends React.Component {
    render(): React.ReactNode {
        return (
            <VMProvider create={() => new VendorItemDashboardViewModel()}>
                {(vm) => (
                    <Scaffold
                        isShowLoading={
                            vm.isLoadingVendorList ||
                            vm.isLoadingVendorDetail ||
                            vm.isSubmittingVendorItems ||
                            vm.isSubmittingNewVendor
                        }
                        loadingBackgroundType="semi_transparent"
                        showSnackbar={vm.snackbarModel}
                    >
                        <div className=" bg-slate-500 overflow-x-auto min-h-screen p-5 mt-10 relative">
                            <h1 className="text-white text-3xl text-center font-bold flex-grow m-5">
                                Vendor Item Dashboard
                            </h1>

                            <VendorItemDashboardSearchWidget
                                onChange={(keyword) =>
                                    vm.filterVendorList(keyword)
                                }
                                value={vm.searchKeyword}
                            />

                            <SizedDiv height={12.0} />

                            {!vm.isLoadingVendorList && (
                                <VendorItemDashboardTableWidget
                                    vendors={vm.filteredVendorList}
                                    onRowClicked={(vendorId) =>
                                        vm.getVendorDetail(vendorId)
                                    }
                                />
                            )}

                            {vm.isShowingVendorDetail && (
                                <VendorItemDashboardItemsModalWidget
                                    selectedVendorName={vm.selectedVendorName}
                                    vendorItemModels={
                                        vm.filteredCurrentVendorItems
                                    }
                                    vendorItemOptions={vm.getVendorItemOptions()}
                                    selectedItemId={vm.selectedItemId}
                                    searchKeyword={
                                        vm.searchCurrentVendorItemsKeyword
                                    }
                                    onChangeKeyword={(value) =>
                                        vm.changeSearchCurrentVendorItemsKeyword(
                                            value
                                        )
                                    }
                                    addedItemIds={vm.addedItemIds}
                                    onChangeSelectedItemId={(itemId) =>
                                        vm.changeSelectedItem(itemId)
                                    }
                                    onAddItem={(itemId) =>
                                        vm.handleAddItem(itemId)
                                    }
                                    onSubmit={() => vm.submitVendorItems()}
                                    onClose={() => vm.closeVendorDetail()}
                                />
                            )}

                            {vm.isShowingCreateVendorModal && (
                                <VendorItemDashboardCreateVendorModalWidget
                                    value={vm.newVendorName}
                                    onClose={() => vm.closeCreateVendorModal()}
                                    onChange={(value) =>
                                        vm.changeVendorName(value)
                                    }
                                    onSubmit={() => vm.submitNewVendor()}
                                />
                            )}

                            {/* Create New Button */}
                            <div className="fixed bottom-4 right-4">
                                <button
                                    className="px-4 py-4 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600"
                                    onClick={() => vm.openCreateVendorModal()}
                                >
                                    Tambahkan Vendor Baru
                                </button>
                            </div>
                        </div>
                    </Scaffold>
                )}
            </VMProvider>
        );
    }
}
